import React from 'react';

/**
 * ErrorBoundary — 런타임 에러 시 앱 전체가 하얗게 되는 것을 방지
 * "문제가 발생했어요" 화면과 "다시 시도" 버튼을 표시
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <span className="error-boundary__emoji">😵</span>
          <h2 className="error-boundary__title">앗, 문제가 발생했어요</h2>
          <p className="error-boundary__desc">
            일시적인 오류입니다. 아래 버튼을 눌러 다시 시도해 주세요.
          </p>
          <button className="btn-primary" onClick={this.handleRetry}>
            🔄 다시 시도
          </button>
          <button
            className="btn-ghost"
            onClick={() => { window.location.href = '/'; }}
          >
            홈으로 돌아가기
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
